import { render } from "./burgerMenu.vue?vue&type=template&id=77fe5046"
import script from "./burgerMenu.vue?vue&type=script&lang=js"
export * from "./burgerMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__